import React from 'react';
import { useSelector } from 'react-redux';
import { getTicketsSelector } from './store/selectors/ticketsSelector';
import BuyTicketsButton from './BuyTicketsButton';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import ticketsReducer from './store/reducers/tickets';
import scheduleDataSource from '@gameday/core/datasources/schedule';
import ticketsDataRequestAction from './store/actions/ticketsDataRequestAction';
const fetchData = () => {
    return ticketsDataRequestAction();
};

initContainerData.register({
    datasources: {
        schedule: scheduleDataSource
    },
    reducers: {
        tickets: ticketsReducer
    }
});

const routes = [{
    path: '/',
    exact: false,
    fetchData
}];

const BuyTicketsButtonDataContainer = () => {
    const ticketsState = useSelector(getTicketsSelector);
    return (
        <BuyTicketsButton { ...ticketsState } />
    );
};

export default BuyTicketsButtonDataContainer;
export { fetchData, routes };
